import type { IconSvgObject } from './types';

const BetweenVerticalEndIcon: IconSvgObject = [
  ["path", { d: "M3 5.99998C3 5.99998 5.20947 3.00001 6.00002 3C6.79058 2.99999 9 6 9 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 15C18 15 21 17.2095 21 18C21 18.7906 18 21 18 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 18H14C10.2288 18 8.34315 18 7.17157 16.8284C6 15.6569 6 13.7712 6 10V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7.5 16.5L12.5 11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BetweenVerticalEndIcon;
